import { create } from 'zustand'

export type ThemeMode = 'light' | 'dark' | 'system'

const STORAGE_KEY = 'minha-obra-theme'

function resolveTheme(mode: ThemeMode): 'light' | 'dark' {
  if (mode === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }
  return mode
}

function applyTheme(resolved: 'light' | 'dark') {
  document.documentElement.dataset.theme = resolved
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) {
    meta.setAttribute('content', resolved === 'dark' ? '#0f1419' : '#F4F2EC')
  }
}

interface ThemeState {
  mode: ThemeMode
  resolved: 'light' | 'dark'
  setMode: (mode: ThemeMode) => void
  init: () => void
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  mode: 'system',
  resolved: 'light',

  setMode: (mode) => {
    localStorage.setItem(STORAGE_KEY, mode)
    const resolved = resolveTheme(mode)
    applyTheme(resolved)
    set({ mode, resolved })
  },

  init: () => {
    const stored = (localStorage.getItem(STORAGE_KEY) as ThemeMode | null) ?? 'system'
    const resolved = resolveTheme(stored)
    applyTheme(resolved)
    set({ mode: stored, resolved })

    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    const onChange = () => {
      if (get().mode === 'system') {
        const next = resolveTheme('system')
        applyTheme(next)
        set({ resolved: next })
      }
    }
    mq.addEventListener('change', onChange)
  },
}))
